import { brandAssets } from '@/config/brandAssets'
import { apexUrl } from '@/lib/tenantHost'

/**
 * A custom domain that points at KAAMCO but isn't a verified workspace (never
 * added, still verifying, or removed). Rendered without the router or API: on
 * an unknown host nothing else can be trusted to load.
 */
export function CustomDomainNotFound(): React.ReactElement {
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-3 bg-white px-6 text-center">
      <img src={brandAssets.logo} alt="KAAMCO" className="mb-4 h-auto w-40 object-contain" />
      <h1 className="text-xl font-bold text-gray-900">Workspace not found</h1>
      <p className="max-w-md text-sm text-gray-600">
        <span className="font-medium text-gray-900">{window.location.hostname}</span> isn&apos;t
        connected to an active KAAMCO workspace yet. If you just set it up, it may still be
        verifying. Otherwise, sign in from the main site.
      </p>
      <a
        href={apexUrl('/login')}
        className="mt-2 rounded-md bg-primary px-4 py-2 text-sm font-medium text-white hover:opacity-90"
      >
        Go to KAAMCO sign in
      </a>
    </div>
  )
}
